import {
    SIGN_INVOICE_BY_CUSTOMER,
    SIGN_INVOICE_BY_EXECUTOR,
    SIGN_RETURN_INVOICE_BY_EXECUTOR
} from "@/store/modules/sign/actions";
import InvoiceServices from '@/services/invoice.service'
import SignService from "@/services/sign/sign.service";
import EImzo from "@/plugins/eimzo";
import * as SignActionResult from "@/enum/SignActionResultCode";
import EventBus from '@/eventbus/global.event.bus'
import * as Events from '@/eventbus/events'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import {AUTH_LOAD_COMPANY_BILLING_INFO} from "@/store/modules/auth/actions";

export default  {
    state: {
        loadedCertificate: null
    },
    getters: {
        isCertificateLoaded(state) {
            return state.loadedCertificate !== null;
        },
        certificate(state) {
            return state.loadedCertificate;
        },
        certificateSerial(state) {
            if (state.loadedCertificate)
                return state.loadedCertificate.certificate.serialNumber

            return null
        }
    },
    mutations: {
        setLoadedCertificate(state, certificate) {
            state.loadedCertificate = certificate;
        },
        unsetLoadedCertificate(state) {
            state.loadedCertificate = null;
        }
    },
    actions: {
        [SIGN_INVOICE_BY_EXECUTOR]: ({dispatch, getters}, id) => {
            dispatch(LAYOUT_LOADING_START)

            InvoiceServices.getSignProperties(id)
                .then(getSignPropertiesResponse => {
                    if (getSignPropertiesResponse.data.HashDetail) {
                        const timestampFn = (signatureHex) => {
                            return new Promise((resolve, reject) => {
                                SignService.getTimeStamp(signatureHex)
                                    .then(getTimeStampResponse => {
                                        resolve(getTimeStampResponse.data);
                                    }, reject);
                            })
                        };

                        const fakturaHashCode = getSignPropertiesResponse.data.HashDetail.FakturaHashCode;
                        const roamingHashCode = getSignPropertiesResponse.data.HashDetail.RoamingOwnerHashCode;

                        if (fakturaHashCode && roamingHashCode) {
                            EImzo.sign(fakturaHashCode, roamingHashCode, getters.certificate, timestampFn)
                                .then(result => {
                                    const signResult = result[0];
                                    const attachTimestampResult = result[1];

                                    SignService.signInvoiceByExecutor(id, {
                                        fakturaPkcs7: signResult.pkcs7,
                                        roamingPkcs7: attachTimestampResult.pkcs7,
                                        certificateSerial: attachTimestampResult.signerSeriaNumber
                                    })
                                        .then(response => {
                                            let busEvent = Events.SignUnknownErrorFailed
                                            switch (response.data) {
                                                case SignActionResult.Success:
                                                    busEvent = Events.SignSuccess
                                                    break;

                                                case SignActionResult.BalanceIsLow:
                                                    busEvent = Events.SignBalanceLowFailed
                                                    break;

                                                case SignActionResult.CreditLimitIsLow:
                                                    busEvent = Events.SignCreditLimitIsLowFailed
                                                    break;

                                                case SignActionResult.SignatureValidationFailed:
                                                    busEvent = Events.SignSignatureValidationFailed
                                                    break;

                                                case SignActionResult.RoamingSignatureValidationFailed:
                                                    busEvent = Events.SignRoamingSignatureValidationFailed
                                                    break;

                                                case SignActionResult.RoamingServiceProcessingError:
                                                    busEvent = Events.SignRoamingServiceProcessingFailed
                                                    break;
                                            }
                                            EventBus.$emit(busEvent, id)
                                            dispatch(AUTH_LOAD_COMPANY_BILLING_INFO)
                                        })
                                        .finally(() => {
                                            dispatch(LAYOUT_LOADING_STOP)
                                        })
                                }, () => {
                                    dispatch(LAYOUT_LOADING_STOP)
                                    EventBus.$emit(Events.SignEimzoFailed, id)
                                })
                        } else {
                            dispatch(LAYOUT_LOADING_STOP)
                            EventBus.$emit(Events.SignGotInvalidHashCode, id)
                        }
                    } else {
                        dispatch(LAYOUT_LOADING_STOP)
                        EventBus.$emit(Events.SignGotInvalidHashCode, id)
                    }
                }, () => {
                    dispatch(LAYOUT_LOADING_STOP)
                    EventBus.$emit(Events.SignGetHashCodeFailed, id)
                })
        },
        [SIGN_INVOICE_BY_CUSTOMER]: ({dispatch, getters}, id) => {
            dispatch(LAYOUT_LOADING_START)

            InvoiceServices.getSignProperties(id)
                .then(getSignPropertiesResponse => {
                    if (getSignPropertiesResponse.data.HashDetail) {
                        const timestampFn = (signatureHex) => {
                            return new Promise((resolve, reject) => {
                                SignService.getTimeStamp(signatureHex)
                                    .then(getTimeStampResponse => {
                                        resolve(getTimeStampResponse.data);
                                    }, reject);
                            })
                        };

                        const fakturaHashCode = getSignPropertiesResponse.data.HashDetail.FakturaHashCode;
                        const roamingHashCode = getSignPropertiesResponse.data.HashDetail.RoamingContractorHashCode;

                        if (fakturaHashCode && roamingHashCode) {
                            EImzo.signByAttach(fakturaHashCode, roamingHashCode, getters.certificate, timestampFn)
                                .then(result => {
                                    const signResult = result[0];
                                    const attachTimestampResult = result[1];

                                    SignService.signInvoiceByCustomer(id, {
                                        fakturaPkcs7: signResult.pkcs7,
                                        roamingPkcs7: attachTimestampResult.pkcs7,
                                        certificateSerial: attachTimestampResult.signerSeriaNumber
                                    })
                                        .then(response => {
                                            let busEvent = Events.SignUnknownErrorFailed
                                            switch (response.data) {
                                                case SignActionResult.Success:
                                                    busEvent = Events.SignSuccess
                                                    break;

                                                case SignActionResult.BalanceIsLow:
                                                    busEvent = Events.SignBalanceLowFailed
                                                    break;

                                                case SignActionResult.CreditLimitIsLow:
                                                    busEvent = Events.SignCreditLimitIsLowFailed
                                                    break;

                                                case SignActionResult.SignatureValidationFailed:
                                                    busEvent = Events.SignSignatureValidationFailed
                                                    break;

                                                case SignActionResult.RoamingSignatureValidationFailed:
                                                    busEvent = Events.SignRoamingSignatureValidationFailed
                                                    break;

                                                case SignActionResult.RoamingServiceProcessingError:
                                                    busEvent = Events.SignRoamingServiceProcessingFailed
                                                    break;
                                            }
                                            EventBus.$emit(busEvent, id)
                                            dispatch(AUTH_LOAD_COMPANY_BILLING_INFO)
                                        })
                                        .finally(() => {
                                            dispatch(LAYOUT_LOADING_STOP)
                                        })
                                }, () => {
                                    dispatch(LAYOUT_LOADING_STOP)
                                    EventBus.$emit(Events.SignEimzoFailed, id)
                                })
                        } else {
                            dispatch(LAYOUT_LOADING_STOP)
                            EventBus.$emit(Events.SignGotInvalidHashCode, id)
                        }
                    } else {
                        dispatch(LAYOUT_LOADING_STOP)
                        EventBus.$emit(Events.SignGotInvalidHashCode, id)
                    }

                }, () => {
                    dispatch(LAYOUT_LOADING_STOP)
                    EventBus.$emit(Events.SignGetHashCodeFailed, id)
                })
        },

        [SIGN_RETURN_INVOICE_BY_EXECUTOR]: ({dispatch, getters}, id) => {
            dispatch(LAYOUT_LOADING_START)
            SignService.getReturnInvoiceSignProperties(id)
                .then(getSignPropertiesResponse => {
                    if (getSignPropertiesResponse.data.HashDetail) {
                        const timestampFn = (signatureHex) => {
                            return new Promise((resolve, reject) => {
                                SignService.getTimeStamp(signatureHex)
                                    .then(getTimeStampResponse => {
                                        resolve(getTimeStampResponse.data);
                                    }, reject);
                            })
                        };

                        const fakturaHashCode = getSignPropertiesResponse.data.HashDetail.FakturaHashCode;
                        const roamingHashCode = getSignPropertiesResponse.data.HashDetail.RoamingOwnerHashCode;

                        if (fakturaHashCode && roamingHashCode) {
                            EImzo.sign(fakturaHashCode, roamingHashCode, getters.certificate, timestampFn)
                                .then(result => {
                                    const signResult = result[0];
                                    const attachTimestampResult = result[1];

                                    SignService.signReturnInvoiceByExecutor(id, {
                                        fakturaPkcs7: signResult.pkcs7,
                                        roamingPkcs7: attachTimestampResult.pkcs7,
                                        certificateSerial: attachTimestampResult.signerSeriaNumber
                                    })
                                        .then(response => {
                                            let busEvent = Events.SignUnknownErrorFailed
                                            switch (response.data) {
                                                case SignActionResult.Success:
                                                    busEvent = Events.SignSuccess
                                                    break;

                                                case SignActionResult.BalanceIsLow:
                                                    busEvent = Events.SignBalanceLowFailed
                                                    break;

                                                case SignActionResult.CreditLimitIsLow:
                                                    busEvent = Events.SignCreditLimitIsLowFailed
                                                    break;

                                                case SignActionResult.SignatureValidationFailed:
                                                    busEvent = Events.SignSignatureValidationFailed
                                                    break;

                                                case SignActionResult.RoamingSignatureValidationFailed:
                                                    busEvent = Events.SignRoamingSignatureValidationFailed
                                                    break;

                                                case SignActionResult.RoamingServiceProcessingError:
                                                    busEvent = Events.SignRoamingServiceProcessingFailed
                                                    break;
                                            }
                                            EventBus.$emit(busEvent, id)
                                            dispatch(AUTH_LOAD_COMPANY_BILLING_INFO)
                                        })
                                        .finally(() => {
                                            dispatch(LAYOUT_LOADING_STOP)
                                        })
                                }, () => {
                                    dispatch(LAYOUT_LOADING_STOP)
                                    EventBus.$emit(Events.SignEimzoFailed, id)
                                })
                        } else {
                            dispatch(LAYOUT_LOADING_STOP)
                            EventBus.$emit(Events.SignGotInvalidHashCode, id)
                        }
                    } else {
                        dispatch(LAYOUT_LOADING_STOP)
                        EventBus.$emit(Events.SignGotInvalidHashCode, id)
                    }
                }, () => {
                    dispatch(LAYOUT_LOADING_STOP)
                    EventBus.$emit(Events.SignGetHashCodeFailed, id)
                })
        }
    }
}